exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".boyutSpan[data-v-55933219]{width:125px}", ""]);

// exports
